/**
 * UltronsSentries.js
 * The UltronsSentries Enemy class
 */

import { Game } from "pixi_core";
import { BubbleColor, EnemyAbilities, GameEvents } from "../Constants";
import { Enemy } from "./Enemy";

export class UltronsSentries extends Enemy {
    /**
     * @public
     * @param {String} enemyName
     * @param {Object} enemyData
     * @param {Number} index
     * @param {Boolean} [summoned] - Summoned by an ability
     */
    constructor(enemyName, enemyData, index, summoned) {
        super(enemyName, enemyData, index, summoned);

        const probAddRandom = Game.utils.assertNumber(enemyData.ProbAddRandom, 1);
        const probAddOvertime = Game.utils.assertNumber(enemyData.ProbAddOvertime, 1);

        // Single ability choice
        this._abilityChoices.addChoice(EnemyAbilities.eADD_RANDOM, probAddRandom);
        this._abilityChoices.addChoice(EnemyAbilities.eULTRON_CONTROL, probAddOvertime);
    }

    /**
     * @protected
     * @override
     * @param {EnemyAbilities} abilityName
     * @param {{x: Number, y: Number}} startPos
     */
    _useAbility(abilityName, startPos) {
        switch (abilityName) {
            case EnemyAbilities.eADD_RANDOM:
                let addBubbleData = {
                    nbBubbles: this._nbBubblesAdd,
                    color: BubbleColor.eRANDOM,
                    startPos: startPos,
                    dodgeFirst: false,
                    callback: this._onAbilityCompleted.bind(this)
                };
                Game.fire(GameEvents.eGAME_ABILITY_ADD_BUBBLE, addBubbleData);
                break;
            case EnemyAbilities.eULTRON_CONTROL:
                Game.fire(GameEvents.eGAME_ABILITY_ADD_OVERTIME, this._addOvertimeBubbles, this._onAbilityCompleted.bind(this));
                break;
            default:
                console.error("[UltronsSentries._useAbility] Invalid ability name : " + abilityName);
                this._chooseNextAction();
        }
    }
}
